import React from 'react';
import ContactForm from '../components/sections/ContactForm';
import GenericSection from '../components/sections/GenericSection';

const Contact = () => {

  return (
    <>
      <ContactForm />
      <GenericSection topDivider className="center-content">
        <div className="container-xs">
          <h3 className="mt-0 mb-16">Other Ways to Connect</h3>
          <p className="m-0 mb-32">
            You can also reach our team directly via email or by phone during standard US business hours.
          </p>
          <ul className="list-reset text-sm">
            <li className="mb-8">
              <strong>Email:</strong> <a href="mailto:info@sees-intl.com">info@sees-intl.com</a>
            </li>
          </ul>
        </div>
      </GenericSection>
    </>
  );
}

export default Contact;
